import type {ReactElement} from 'react';
import {ControlledList} from '@Components/controlled-list';
import type {ControlledListItemType} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE} from '@Components/controlled-list/controlled-list.types';

interface ReplaceMediaControlsProps {
  id?: string;
  className?: string;
  showAiVideoOption?: boolean;
  showAiImageOption?: boolean;
  /** Sticker-replace context: the AI image option renders as "AI Stickers" (the click still routes through AI_IMAGES). */
  showAiImageOptionAsStickers?: boolean;

  onClick(option: ReplaceMediaControlsButtons): void;
}

export enum ReplaceMediaControlsButtons {
  EXPLORE_MEDIA = 'explore-media-option',
  MY_UPLOADS = 'my-uploads-option',
  AI_VIDEOS = 'ai-videos-option',
  AI_IMAGES = 'ai-images-option',
}

export function ReplaceMediaControls({
  id = '',
  className = '',
  showAiVideoOption = false,
  showAiImageOption = false,
  showAiImageOptionAsStickers = false,
  ...props
}: ReplaceMediaControlsProps): ReactElement {
  const getItems = (): ControlledListItemType[] => {
    const items: ControlledListItemType[] = [
      {
        id: ReplaceMediaControlsButtons.MY_UPLOADS,
        text: window.i18next.t('pmwjs_uploads'),
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
        icon: 'icon-upload',
        onClick: (): void => {
          props.onClick(ReplaceMediaControlsButtons.MY_UPLOADS);
        },
      },
      {
        id: ReplaceMediaControlsButtons.EXPLORE_MEDIA,
        text: window.i18next.t('pmwjs_media'),
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
        icon: 'icon-media',
        onClick: (): void => {
          props.onClick(ReplaceMediaControlsButtons.EXPLORE_MEDIA);
        },
      },
    ];

    if (showAiImageOption) {
      items.push({
        id: ReplaceMediaControlsButtons.AI_IMAGES,
        text: window.i18next.t(showAiImageOptionAsStickers ? 'pmwjs_ai_stickers_caps' : 'pmwjs_ai_images'),
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
        icon: showAiImageOptionAsStickers ? 'icon-ai-sticker' : 'icon-ai-image',
        textClasses: 'content-ai',
        iconClasses: 'content-ai',
        onClick: (): void => {
          props.onClick(ReplaceMediaControlsButtons.AI_IMAGES);
        },
      });
    }

    if (showAiVideoOption) {
      items.push({
        id: ReplaceMediaControlsButtons.AI_VIDEOS,
        text: window.i18next.t('pmwjs_ai_videos'),
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
        icon: 'icon-video-ai',
        textClasses: 'content-ai',
        iconClasses: 'content-ai',
        onClick: (): void => {
          props.onClick(ReplaceMediaControlsButtons.AI_VIDEOS);
        },
      });
    }

    return items;
  };

  return <ControlledList className={`spacing-m-0 ${className}`} items={getItems()} />;
}
